import { render, staticRenderFns } from "./selectCity.vue?vue&type=template&id=4d8879f2&"
import script from "./selectCity.vue?vue&type=script&lang=ts&"
export * from "./selectCity.vue?vue&type=script&lang=ts&"
import style0 from "./selectCity.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports